import type * as core from '../../../../../../../core'

export const query: core.mosaic.Action.Query = {
  selection: {
    '{}': {
      payload: {
        '{}': {
          widgetId: '399',
          variables: {
            '{}': {
              externalInstitutionId: {
                '@$': 'externalInstitutionId',
              },
            },
          },
        },
      },
      operation: 'ui.modal',
    },
  },
}
